<template>
  <header class="app-header">
    <router-link class="app-header__logo" to="/">{{name_en}}</router-link>
    <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Hide Sidebar"></a>
    <ul class="app-nav">

      <li class="dropdown">
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="Show notifications"><i
            class="bi bi-bell fs-5"></i></a>
        <ul class="app-notification dropdown-menu dropdown-menu-right">
          <!-- Notification items -->
          <li class="app-notification__title">You have 4 new notifications.</li>
          <div class="app-notification__content">
            <!-- Replace with dynamic notification items if needed -->
            <li><a class="app-notification__item" href="javascript:;"><span class="app-notification__icon"><i
                    class="bi bi-envelope fs-4 text-primary"></i></span>
                <div>
                  <p class="app-notification__message">Lisa sent you a mail</p>
                  <p class="app-notification__meta">2 min ago</p>
                </div>
              </a></li>
            <!-- More notifications here -->
          </div>
          <li class="app-notification__footer"><router-link to="/notifications">See all notifications.</router-link>
          </li>
        </ul>
      </li>
      <li class="dropdown">
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="Open Profile Menu"><i
            class="bi bi-person fs-4"></i></a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <li><router-link class="dropdown-item" to="/settings"><i class="bi bi-gear me-2 fs-5"></i>
              Settings</router-link></li>
          <li><router-link class="dropdown-item" to="/profile"><i class="bi bi-person me-2 fs-5"></i>
              Profile</router-link></li>
          <!-- <li><router-link class="dropdown-item" to="/login"><i class="bi bi-box-arrow-right me-2 fs-5"></i>
              Logout</router-link></li> -->
              <li><a @click="logout" class="dropdown-item" href="#"><i class="bi bi-box-arrow-right me-2 fs-5"></i>
                ออกจากระบบ</a></li>
        </ul>
      </li>
    </ul>
  </header>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Navbar',
  data() {
    return {
      name: process.env.VUE_APP_NAME,
      name_en: process.env.VUE_APP_NAME_EN,
    }
  },
  mounted() {
    // this.initializeJQuery();
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    initializeJQuery() {
      // Toggle Sidebar
      $('[data-toggle="sidebar"]').click((event) => {
        
        event.preventDefault();
        $('.app').toggleClass('sidenav-toggled');
      });

      // Activate sidebar treeview toggle
      $("[data-toggle='treeview']").click((event) => {
        event.preventDefault();
        if (!$(event.currentTarget).parent().hasClass('is-expanded')) {
          $('.app-menu').find("[data-toggle='treeview']").parent().removeClass('is-expanded');
        }
        $(event.currentTarget).parent().toggleClass('is-expanded');
      });
    },
  }
};
</script>

<style scoped>
.app-header__logo {
  font-size: 25px;
}
</style>